import api from './api';
import { CPB_URL } from './servers';

export const fetchDownloadExcel = (data) => api.post(`${CPB_URL}/reporte/getReportUsr`, data);

export const fetchExcelDipos = (data) => api.post(`${CPB_URL}/reporte/getReportDispos`, data);

export const fetchExcelPropViaP = (data) => api.post(`${CPB_URL}/reporte/getReportProViaPub`, data);

export const fetchExcelMediosImp = (data) =>
  api.post(`${CPB_URL}/reporte/getReportMediosImp`, data);

export const fetchExcelVisEventos = (data) =>
  api.post(`${CPB_URL}/reporte/getReportVisitasEventos`, data);

export const fetchExcelActas = (data) => api.post(`${CPB_URL}/reporte/getReporteActas`, data);

export const fetchExcelHallazgos = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteHallazgos`, data);

export const fetchExcelByMonitoreo = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteMonitoreos`, data);

export const fetchExcelCatalogMI = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteCatalogoMedidas`, data);

export const fetchExcelCatFechas = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteCatalogoFechas`, data);

export const fetchExcelEnlaces = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteGeneracionEnlaces`, data);

export const fetchExcelBitacoraSync = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteBitacoraSincronizacion`, data);

export const fetchExcelReporteUsuarios = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteUsuariosReporte`, data);

export const fetchExcelPublicDownloads = (data) =>
  api.post(`${CPB_URL}/consultaPublica/getReporteConsultaPublica`, data);

export const fetchExcelConfigCatalogos = (data) =>
  api.post(`${CPB_URL}/reporte/getReporteCatalogoHallazgos`, data);
